/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as S from './AdForm.styles';
import { DrawerItems } from '@/components/Drawer/Drawer.styles';
import { Button } from '@/components/UI/Button/Button';
import { Input } from '@/components/UI/Input/Input';
import { Checkbox } from '@/components/UI/Checkbox/Checkbox';
import { AdImages } from '@/components/AdImages/AdImages';
import NoSsr from '@/components/NoSsr/NoSsr';
import { Textarea } from '@/components/UI/Textarea/Textarea';
import {
  EditAdFormFields,
  editAdFormSchema,
} from '@/components/AdForm/AdForm.types';
import { AdImagesRef } from '@/components/AdImages/AdImages.types';

export const EditAdForm = () => {
  const { t } = useTranslation();
  const adImagesRef = useRef<AdImagesRef>(null);

  const { control, handleSubmit, reset, setValue, clearErrors } =
    useForm<EditAdFormFields>({
      resolver: zodResolver(editAdFormSchema),
      defaultValues: {
        price: '',
        isDelivery: false,
        description: '',
        images: [],
      },
    });

  function onSubmit(data: EditAdFormFields) {
    console.log('submit', data);
  }

  useEffect(() => {
    // TODO: reset with real data after connecting BE
    reset({
      price: '123',
      isDelivery: true,
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, voluptatum.',
      images: [{ id: '1', src: 'https://picsum.photos/200/300' }],
    });
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <DrawerItems>
        <Controller
          name="isDelivery"
          control={control}
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          render={({ field: { ref, ...rest } }) => (
            <Checkbox {...rest} label="Доставка?" />
          )}
        />
      </DrawerItems>

      <DrawerItems $isInTheMiddle>
        <Controller
          name="price"
          control={control}
          render={({ field, fieldState }) => (
            <Input
              {...field}
              type="number"
              label={t('pages.new_ad.price')}
              required
              helperText={fieldState.error?.message}
              hasError={!!fieldState.error}
              hasBorderBottom={false}
            />
          )}
        />
      </DrawerItems>

      <S.AdFormTextareaBox $isInTheMiddle>
        <NoSsr>
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <Textarea
                {...field}
                height={120}
                label={t('pages.new_ad.ad_text')}
                placeholder={t('pages.new_ad.mark_benefits')}
                withSymbolsCount
              />
            )}
          />
        </NoSsr>
      </S.AdFormTextareaBox>

      {/* TODO remove NoSsr after backend will be connected */}
      <NoSsr>
        <S.AdFormImagesBox $isInTheMiddle>
          <Controller
            name="images"
            control={control}
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            render={({ field: { ref, ...rest }, fieldState }) => (
              <AdImages
                {...rest}
                onChange={images => {
                  if (images.length) {
                    clearErrors(rest.name);
                  }
                  setValue(rest.name, images);
                }}
                ref={adImagesRef}
                helperText={fieldState.error?.message}
                hasError={!!fieldState.error}
              />
            )}
          />
        </S.AdFormImagesBox>
      </NoSsr>

      <S.AdFormSubmitBox>
        <Button appearance="primary" isFullWidth type="submit">
          {t('pages.new_ad.save_ad')}
        </Button>
      </S.AdFormSubmitBox>
    </form>
  );
};
